import { Component, DestroyRef, Input, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { GreyhoundParticipantInfo, WinGameFixture, WinGameParticipant } from '@frontend/sports/racing/feature/models';
import { Observable } from 'rxjs';

import { RacingService } from '../../../services/racing-service';

@Component({
    selector: 'ms-gh-trap-images',
    templateUrl: './gh-trap-images.component.html',
    standalone: false,
})
export class GhTrapImagesComponent implements OnInit {
    trapImages$: Observable<{ [key: string]: string }>;
    @Input() greyhoundTrapDogMapping: { [id: number]: GreyhoundParticipantInfo } = {};
    @Input({ required: true }) participant: WinGameParticipant;
    @Input() isOptionBet = false;
    @Input() fixture: WinGameFixture;

    private readonly destroyRef = inject(DestroyRef);

    constructor(private readonly racingService: RacingService) {}

    ngOnInit(): void {
        this.trapImages$ = this.racingService.getTraps$(this.fixture.region.id).pipe(takeUntilDestroyed(this.destroyRef));
    }

    getImageUrl(trapImages: { [key: string]: string }): string {
        if (!this.isOptionBet) {
            return trapImages[this.participant.participantId];
        }

        const trapNumber =
            this.participant.properties?.cloth ||
            this.greyhoundTrapDogMapping?.[this.participant.participantId]?.cloth ||
            this.participant.participantId;

        return trapImages[trapNumber];
    }
}
